module.exports = __webpack_public_path__ + "img/kilian_landwehr_preview.0230274d.png";